import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getStockLedgerReport = catchAsync(
  async (
    currentLang,
    companyName = '',
    from_date,
    to_date,
    warehouse = '',
    item_code = '',
    stock_uom = '',
    voucher_no = ''
  ) => {
    const { data } = await axiosInstance.get(
      // `/api/method/technoerp.services.get_report?report_name=Stock Ledger&filters={"company":"${companyName}","from_date":"2024-10-08","to_date":"2024-11-08","valuation_field_type":"Currency"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
      `/api/method/technoerp.services.get_report?report_name=Stock Ledger&api/method/techno.services.get_report?report_name=Stock Ledger&filters={"company":"${companyName}","from_date":"${from_date}","to_date":"${to_date}","valuation_field_type":"Currency","item_code": "${item_code}","voucher_no": "${voucher_no}","warehouse": "${warehouse}","stock_uom": "${stock_uom}"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
    );
    return data;
  }
);
export const getPurchaseAnalytics = catchAsync(
  async (currentLang, companyName = '', from_date, to_date) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?ignore_prepared_report=false&are_default_filters=false&filters={"tree_type":"Supplier","doc_type":"Purchase Receipt","value_quantity":"Value","from_date":"${from_date}","to_date":"${to_date}","company":"${companyName}","range":"Monthly"}&report_name=Purchase Analytics&_lang=${currentLang}`
    );
    return data;
  }
);
export const getStockAnalytics = catchAsync(
  async (currentLang, companyName = '', from_date, to_date, warehouse = '') => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?ignore_prepared_report=false&are_default_filters=false&filters={"value_quantity":"Quantity","company":"${companyName}","warehouse":"${warehouse}","from_date":"${from_date}","to_date":"${to_date}","range":"Monthly"}&report_name=Stock Analytics&_lang=${currentLang}&_=1731064939081`
    );
    return data;
  }
);
export const getItemPriceReport = catchAsync(async (currentLang) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_report?report_name=Item Prices&ignore_prepared_report=false&are_default_filters=false&_lang=${currentLang}&_=1731064939081`
  );
  return data;
});
